import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '../../utils';
var colors = tokens.colors;
var container = {
  base: /*#__PURE__*/css("display:flex;padding:16px 24px;background:", colors.neutral.surface.default, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:3px;width:100%;"),
  horizontal: {
    name: "1n9gppf",
    styles: "flex-direction:row;align-items:center;gap:16px;"
  },
  vertical: {
    name: "kln4oz",
    styles: "flex-direction:column;align-items:flex-start;gap:8px;min-width:243px;"
  }
};
var content = {
  base: {
    name: "hboir5",
    styles: "display:flex;width:100%;"
  },
  horizontal: {
    name: "3r9uwd",
    styles: "flex-direction:row;align-items:center;justify-content:space-between;gap:4px;"
  },
  vertical: {
    name: "9bh1tu",
    styles: "flex-direction:column;align-items:flex-start;gap:16px;"
  }
};
var text = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;color:", colors.neutral.heavy.default, ";");
var title = {
  base: /*#__PURE__*/css(designTokenFonts.displaySmall),
  vertical: {
    name: "1s00u8u",
    styles: "line-height:28px;"
  }
};
var subtitle = {
  base: /*#__PURE__*/css(designTokenFonts.body),
  vertical: {
    name: "1wsccn1",
    styles: "line-height:24px;"
  }
};
export default (function () {
  var appearance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'horizontal';
  var buildStyle = style => [style.base, style[appearance]];
  return {
    container: buildStyle(container),
    content: buildStyle(content),
    text,
    title: buildStyle(title),
    subtitle: buildStyle(subtitle)
  };
});